import { DEFAULT_VALUE } from "@/config";
import { get, isNil, isUndefined } from "lodash-es";

/**
 * 将对象转化为formData
 * @param obj
 * @param checkVoid
 */
export function convertObjectToFormData(obj: any, checkVoid?: boolean): FormData {
    const formData = new FormData();
    const checkedVoid = checkVoid || false;
    for (const key of Object.keys(obj)) {
        if (!checkedVoid) {
            if (obj[key] !== undefined && obj[key] !== null && obj[key] !== "" && obj[key].length !== 0) {
                if (Array.isArray(obj[key]) && Object.prototype.toString.call(obj[key][0])) {
                    obj[key].forEach((value: any) => {
                        formData.append(key, value);
                    });
                } else {
                    formData.append(key, obj[key]);
                }
            }
        } else if (obj[key] !== undefined && obj[key] !== "") {
            if (Array.isArray(obj[key]) && Object.prototype.toString.call(obj[key][0])) {
                obj[key].forEach((value: any) => {
                    formData.append(key, value);
                });
            } else {
                formData.append(key, obj[key]);
            }
        }
    }
    return formData;
}

export function getDefaultValue(value: unknown, defaultValue: string = DEFAULT_VALUE) {
    return isNil(value) ? defaultValue : value;
}

// 获取属性值
export function getValueByProp(data: any, prop: string, defaultValue?: any) {
    const defaultText = isUndefined(defaultValue) ? DEFAULT_VALUE : defaultValue;
    const value = get(data, prop);
    return isNil(value) || value === "" ? defaultText : value;
}

/**
 * 根据路径安全地从对象中获取值（支持 "a.b.c" 或 ["a", "b", "c"]）
 *
 * @param data  源对象
 * @param path  访问路径，可以是字符串形式 "a.b.c"，也可以是数组形式 ["a", "b", "c"]
 *
 * @returns
 * - 找到值时，返回对应的值（string | number | null | undefined）
 * - 路径非法 / 数据不存在 / 中途取值失败时，返回 undefined
 */
export function getValueByPath(
    data: Record<string, unknown>,
    path: string | string[]
): string | number | null | undefined {
    const pathReg = /^([a-zA-Z_][a-zA-Z0-9_]*)(\.[a-zA-Z_][a-zA-Z0-9_]*)*$/;
    if (!data) return;
    if (Array.isArray(path)) {
        if (!path.length) return;
    } else {
        if (!pathReg.test(path)) return;
        path = path.split(".");
    }
    const key: string = path.shift() as string;
    const value = data[key];
    if (!path.length) return value as string | number | null | undefined;
    return getValueByPath(value as Record<string, unknown>, path);
}
